<!-- @format -->
<script lang="ts">
  import { createEventDispatcher } from "svelte";
  import type { ManageAPI } from "~/manage-api/types";
  import type { StoresKey } from "~/stores";
  import { getStoresContext } from "~/stores";
  import DropDown from "./DropDown.svelte";
  
  export let request_store_key: StoresKey;
  const dispatch = createEventDispatcher();
  const { T } = getStoresContext(request_store_key);
  export let currentFloorStores: ManageAPI.Store[] = [];
  export let selected_store: ManageAPI.Store | undefined;

  function changeStore() {
    dispatch("changeStore", select);
  }

  $: showDropdown = false;
  let select: string | Number;
  $: t = $T;
</script>

<DropDown {showDropdown}>
  <svelte:fragment slot="default-value">
    {#if select && selected_store}
      {currentFloorStores.find(x => x.id == select)?.name}
    {:else}
      {t`choose-store`}
    {/if}
  </svelte:fragment>
  <svelte:fragment slot="options">
    {#each currentFloorStores as store}
      <button
        class="option"
        on:click={() => {
          showDropdown = false;
          select = store.id;
          changeStore();
        }}>
        {store.name}
      </button>
    {/each}
  </svelte:fragment>
</DropDown>

<style lang="scss">
  .option {
    display: block;
    background-color: var(--color-white);
    width: 100%;
    border: none;
    padding: 0.25rem 0.5rem;
    text-align: left;
    font-size: 18px;
    color: var(--color-black);
  }
  .option:hover {
    background-color: var(--color-black);
    color: var(--color-white);
  }
</style>
